export default "__VITE_ASSET__zmy9gJQw__"